import React from "react";
import { Link } from "react-router-dom";

import { tw } from "~/utils";

interface ProtectedByRecaptchaProps {
  className?: string;
}

export const ProtectedByRecaptcha = ({
  className,
}: ProtectedByRecaptchaProps) => {
  return (
    <p className={tw("mb-0 flex items-start gap-1 font-sans", className)}>
      <span>
        This site is protected by reCAPTCHA and the Google{" "}
        <Link
          className="underline"
          to="https://policies.google.com/privacy"
          target="_blank"
          role="link"
        >
          Privacy Policy
          <span className="sr-only"> (opens in a new tab)</span>
        </Link>{" "}
        and{" "}
        <Link
          className="underline"
          to="https://policies.google.com/terms"
          target="_blank"
          role="link"
        >
          Terms of Service
          <span className="sr-only"> (opens in a new tab)</span>
        </Link>{" "}
        apply.
      </span>
    </p>
  );
};
